const register = {
  loginCredentials: "Prisijungimo kredencialai", // translated
  companyInformation: "Kompanijos informacija", // translated
  contactDetails: "Kontaktiniai duomenys", // translated
  businessName: "Verslo pavadinimas", // translated
  businessAddress: "Verslo adresas", // translated
  registrationCode: "Registracijos kodas", // translated
  businessRegistrationNumber: "Įmonės registracijos numeris", // translated
  websiteUrl: "Svetainės URL", // translated
  mobilePhone: "Mobilusis telefonas", // translated
  regionStateProvince: "Regionas/valstybė/provincija", // translated
  legalTitle: "Teisinis pavadinimas", // translated
  city: "Miestas", // translated
  postalCode: "Pašto kodas", // translated
  registrationSuccess: "Registracija sėkminga.", // translated
  pleaseWaitFewMomentsAndYouWillBeRedirectedToHome:
    "Palaukite kelias minutes ir būsite nukreipti į pagrindinį puslapį.", // translated
  usernameEmail: "Naudotojo vardas (el. paštas)", // translated
  password: "Slaptažodis", // translated
  verifyPassword: "Patvirtinti slaptažodį", // translated
  documents: "Dokumentai", // translated
  termsAndConditionsSection: "Sąlygos", // translated
  certificateOfIncorporation: "Įkūrimo pažymėjimas", // translated
  acceptTermsAndConditions: "Sutinku su sąlygomis", // translated
  country: "Šalis", // translated
  brandName: "Prekės ženklas", // translated
  register: "Registruotis", // translated
  isRequired: "Privaloma", // translated
  passwordMin8Chars: "Turi būti bent 8 simboliai", // translated
  passwordRequiresDigit: "Turi būti bent 1 skaitmuo", // translated
  passwordRequiresLowercase: "Turi būti bent 1 mažoji raidė", // translated
  passwordRequiresUppercase: "Turi būti bent 1 didžioji raidė", // translated
  passwordRequiresSpecialChar: 'Turi būti bent 1 specialusis simbolis (!@#$%^&*(),.?":{}|<>)', // translated
  uploadFile: "Įkelti failą", // translated
  filename: "Failo pavadinimas:", // translated
  fileType: "Tipas:", // translated
  fileSize: "Dydis:", // translated
  maxFileSize10Mb: "Maks.: 10 MB", // translated
  supportedFileTypes: "Palaikomi failų tipai:", // translated
  showPassword: "Rodyti slaptažodį", // translated
  hidePassword: "Slėpti slaptažodį", // translated
  notAvailable: "Nėra", // translated
  fileSizeInKb: "{{size}} KB", // translated
  mobilePhonePlaceholder: "pvz. +37061234567", // translated
  websiteUrlPlaceholder: "http://www.pavyzdys.lt", // translated
  loading: "Įkeliama...", // translated
  uploadingDocument: "Įkeliamas dokumentas...", // translated
  percentUploaded: "{{percent}}% įkelta", // translated
  registrationSuccessful: "Registracija sėkminga.", // translated
  failedToUploadDocument: "Nepavyko įkelti dokumento.", // translated
  fieldIsRequired: "{{field}} {{isRequired}}", // translated
  fieldMinLength: "{{field}} turi būti ilgesnis nei {{min}} simboliai", // translated
  fieldMustBeValidEmail: "{{field}} turi būti galiojantis el. paštas", // translated
  fieldPasswordMinLength: "{{field}} turi būti bent 8 simboliai", // translated
  fieldPasswordRequiresDigit: "{{field}} turi būti bent 1 skaitmuo", // translated
  fieldPasswordRequiresLowercase: "{{field}} turi būti bent 1 mažoji raidė", // translated
  fieldPasswordRequiresUppercase: "{{field}} turi būti bent 1 didžioji raidė", // translated
  fieldPasswordRequiresSpecialChar:
    '{{field}} turi būti bent 1 specialusis simbolis (!@#$%^&*(),.?":{}|<>)', // translated
  passwordsDoNotMatch: "{{field}} nesutampa su {{otherField}}", // translated
  fieldBetweenLength: "{{field}} turi būti nuo {{min}} iki {{max}} simbolių", // translated
  postalCodeBetweenLength: "{{field}} turi būti nuo {{min}} iki {{max}} simbolių", // translated
  invalidUrlFormat: "Netinkamas URL formatas", // translated
  invalidEmailFormat: "Netinkamas el. pašto formatas", // translated
  emailMustMatchUsername: "el. paštas turi sutapti su naudotojo vardu (el. paštas)", // translated
  mobilePhoneIsRequired: "Mobilusis telefonas yra privalomas", // translated
  certificateFileTooLarge: "Įkūrimo pažymėjimo failas per didelis", // translated
  termsMustBeAccepted: "Būtina sutikti su sąlygomis", // translated
};


export default register;
